/**
 * https://www.figma.com/file/7Gfry5KCHWtM3ur73RKhMu/Question-Indexing-UI?node-id=498%3A7176
 */

import classNames from "classnames";
import React, { ReactElement } from "react";
import styles from "./cta.module.scss";
import { useTranslation } from "next-i18next";
import {
  CoinBaseIcon,
  CoinIconState,
} from "../../../../common/components/navbar/coinIcon";

export const ShowAnswerWithCreditCta = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");

  return (
    <div className={styles.showAnswerWithCredit}>
      <div>
        <p className={styles.title}>
          {t(
            "question_indexing_answer_component_show_answer_state_primary_proposition_text"
          )}
        </p>
        <p className={styles.desc}>
          {t(
            "question_indexing_answer_component_show_answer_state_secondary_proposition_text"
          )}{" "}
        </p>
      </div>
      <div className={classNames(styles.rightColumn)}>
        <button onClick={props.onShowClicked} className={styles.ctaButton}>
          <CoinBaseIcon state={CoinIconState.UNLIMITED} size={20} />
          <span>
            {t(
              "question_indexing_answer_component_show_answer_state_cta_label"
            )}
          </span>
        </button>
        <p className={styles.secondaryCta}>
          {t(
            "question_indexing_answer_component_show_answer_state_cta_disclaimer",
            {
              credits: props.credits,
            }
          )}
        </p>
      </div>
    </div>
  );
};

interface Props {
  onShowClicked: () => void;
  credits: number;
}

export default ShowAnswerWithCreditCta;
